import api from '../config/api';

export const vacancyService = {
    /**
     * Get all vacancies (for employees)
     * @param {Object} filters
     * @returns {Promise}
     */
    getAll: async (filters = {}) => {
        const response = await api.get('/employee/vacancies', { params: filters });
        return response.data;
    },

    /**
     * Get vacancy by ID (for employees)
     * @param {number} id
     * @returns {Promise}
     */
    getById: async (id) => {
        const response = await api.get(`/employee/vacancies/${id}`);
        return response.data;
    },

    /**
     * Get company vacancy by ID
     * @param {number} id
     * @returns {Promise}
     */
    getCompanyVacancyById: async (id) => {
        const response = await api.get(`/company/vacancies/${id}`);
        return response.data;
    },

    /**
     * Apply for a vacancy
     * @param {number} vacancyId
     * @param {FormData} formData
     * @returns {Promise}
     */
    apply: async (vacancyId, formData) => {
        const response = await api.post(`/employee/vacancies/${vacancyId}/apply`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },

    /**
     * Save a vacancy
     * @param {number} vacancyId
     * @returns {Promise}
     */
    save: async (vacancyId) => {
        const response = await api.post(`/employee/vacancies/${vacancyId}/save`);
        return response.data;
    },

    /**
     * Unsave a vacancy
     * @param {number} vacancyId
     * @returns {Promise}
     */
    unsave: async (vacancyId) => {
        const response = await api.post(`/employee/vacancies/${vacancyId}/unsave`);
        return response.data;
    },

    /**
     * Get saved vacancies
     * @returns {Promise}
     */
    getSaved: async () => {
        const response = await api.get('/employee/vacancies/saved');
        return response.data;
    },

    /**
     * Get applications
     * @returns {Promise}
     */
    getApplications: async () => {
        const response = await api.get('/employee/vacancies/applications');
        return response.data;
    },

    /**
     * Withdraw application
     * @param {number} vacancyId
     * @returns {Promise}
     */
    withdrawApplication: async (vacancyId) => {
        const response = await api.delete(`/employee/vacancies/${vacancyId}/withdraw`);
        return response.data;
    },

    // Company methods
    /**
     * Get company vacancies
     * @param {Object} filters
     * @returns {Promise}
     */
    getCompanyVacancies: async (filters = {}) => {
        const response = await api.get('/company/vacancies', { params: filters });
        return response.data;
    },

    /**
     * Create vacancy (company)
     * @param {Object} data
     * @returns {Promise}
     */
    create: async (data) => {
        const response = await api.post('/company/vacancies', data);
        return response.data;
    },

    /**
     * Update vacancy (company)
     * @param {number} id
     * @param {Object} data
     * @returns {Promise}
     */
    update: async (id, data) => {
        const response = await api.put(`/company/vacancies/${id}`, data);
        return response.data;
    },

    /**
     * Delete vacancy (company)
     * @param {number} id
     * @returns {Promise}
     */
    delete: async (id) => {
        const response = await api.delete(`/company/vacancies/${id}`);
        return response.data;
    },

    /**
     * Get vacancy applications (company)
     * @param {number} vacancyId
     * @returns {Promise}
     */
    getVacancyApplications: async (vacancyId) => {
        const response = await api.get(`/company/vacancies/${vacancyId}/applications`);
        return response.data;
    },

    /**
     * Change application status (company)
     * @param {number} vacancyId
     * @param {number} applicationId
     * @param {string} status
     * @returns {Promise}
     */
    changeApplicationStatus: async (vacancyId, applicationId, status) => {
        const response = await api.put(`/company/vacancies/${vacancyId}/applications/${applicationId}/status`, { status });
        return response.data;
    },
};


